import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  LOCALE_ID,
  NgZone,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { ColDef, ColumnApi, GridApi, GridOptions } from 'ag-grid-community';
import moment, { max, min } from 'moment';
import { KEYS, ORDER_ATTACHMENT_TYPE, OrderType, Show } from '@pos-app/data';
import { BehaviorSubject, Subject } from 'rxjs';
import {
  ApiService,
  AttachmentEntityType,
  CoreUiPartialState,
  getBrandDefaults,
  hasUnsavedChanges,
  MessageService,
  saveCustomerOrderDetailsForTask,
  SpinnerService,
} from '@pos-app/core-ui';
import { CustomersPartialState } from '../../../+state/customers.reducer';
import { select, Store } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomerPOSJobOrderGridActionRenderComponent } from '../../../../orders/components/customerOrderGridActionrRenderer/customerPOSJobOrderGridActionRenderer.component';
import { takeUntil, finalize } from 'rxjs/operators';
import { FetchJdeOrder } from '../../../../orders/+state/orders.actions';
import { getUserAssignedCurrencyFormat } from '@pos-app/core-ui/lib/utils/locale-helper';
import { Router } from '@angular/router';
import { GetClickAndCollectStatusAction, GetUserSalesPersonListAction, saveJobRequestActiveNavIndex } from '../../../+state/customers.actions';
import { customersQuery } from '../../../+state/customers.selectors';
import { ordersQuery } from '../../../../orders/+state/orders.selectors';
import { getformatedTime } from '../../../../scheduler/scheduler-helper';
import { J } from '@angular/cdk/keycodes';
import { CentralPartialState } from '../../../../central/+state/central.reducer';
import { centralQuery } from '../../../../central/+state/central.selectors';
import { LoadOpenJobRequestTotals } from '../../../../central/+state/central.actions';
import { CoreUiModule } from '../../../../../../../../../libs/core-ui/src/lib/core-ui.module';
import { NgFor, NgClass, NgIf, AsyncPipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { NgSelectComponent, NgOptionComponent } from '@ng-select/ng-select';
import { AgGridModule } from 'ag-grid-angular';

@Component({
    selector: 'app-customers-pos-arb-orders',
    templateUrl: './customers-pos-arb-orders.component.html',
    styleUrls: ['./customers-pos-arb-orders.component.scss'],
    imports: [CoreUiModule, NgFor, NgClass, NgIf, AsyncPipe, FormsModule, MatIcon, NgSelectComponent, NgOptionComponent, AgGridModule]
})
export class CustomerPosArbOrdersComponent implements OnInit, OnDestroy {
  @ViewChild('content') modalBox: ElementRef;
  @Output() onFetchOrderFromJDE = new EventEmitter();

  gridOptions: GridOptions;
  columnDefs: ColDef[];
  frameworkComponents;
  context;
  rowData = [];
  filteredRowData = [];
  searchValue: string;
  orderDetails: any;
  isReadOnlyLineAttachment: boolean;
  ORDER_ATTACHMENT_TYPE = ORDER_ATTACHMENT_TYPE;

  private unSubscribe$ = new Subject<void>();
  private gridApi: GridApi;
  private gridColumnApi: ColumnApi;
  public loading$ = new BehaviorSubject<boolean>(false);
  get loading(): boolean {
    return this.loading$.value;
  }
  set loading(v: boolean) {
    this.loading$.next(v);
  }
  currencyCode: any;
  salesPeopleList: any;
  selectedSalesPerson: string;
  formValid: boolean;
  allAttachments: any[];
  entityId: string;
  entityType: AttachmentEntityType;
  defaultCompanyCode: string = JSON.parse(localStorage.getItem('jdeSession')).CompanyCode;
  madeChanges: boolean = false;
  private _loadingFetchingOrderFromJDE: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  loadingFetchingOrderFromJDE$ = this._loadingFetchingOrderFromJDE.asObservable();
  get loadingFetchingOrderFromJDEValue(): boolean {
    return this._loadingFetchingOrderFromJDE.value;
  }
  set loadingFetchingOrderFromJDEValue(v: boolean) {
    this._loadingFetchingOrderFromJDE.next(v);
  }
  isShowOrderAttachment: boolean = false;
  isShowSalesPersonSelector: boolean;
  jobRequestActiveNavIndex: number = -1;
  isClickAndCollect: boolean = false;
  isEcomQuote: boolean = false;
  isFLAOrder: boolean = false;
  customerShowList: Show[] = [];
  selectedTradeShowOrder: string = '';
  selectedShow: string = '';
  selectedShowOrderType: string[] = [];
  showTradeShowOrderListMenuOnly: boolean = false;
  previouslySelectedShow: string = JSON.parse(localStorage.getItem('jdeSession')).ShowCode || '';
  previouslySelectedShowOrderType: string[] = JSON.parse(localStorage.getItem('jdeSession')).ShowOrderType || [];

  notificationNavs = [
    { label: 'Click and Collect', badgeCount: 0 },
    { label: 'Ecom Quotes', badgeCount: 0 },
    { label: 'Ford Licensed Accessories', badgeCount: 0 },
    { label: 'Fleet', badgeCount: 0 },
    { label: 'Trade Show Orders', badgeCount: 0 },
  ];
  lastCentralJobRequestData: any;
  isShowAdvanceFilter: boolean = false;
  filterAssignedToMe: boolean = false;
  statusPrintPick: boolean = false;
  statusAcceptOrder: boolean = false;
  statusEcomNotifying: boolean = false;
  statusCustomerNotified: boolean = false;
  statusCollected: boolean = false;
  showTradeShowOrderList: boolean = false;
  clickAndCollectStatus: any;
  selectedStatusCodes: string[] = [];

  constructor(
    private apiService: ApiService,
    private customerStore: Store<CustomersPartialState>,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private coreUiStore: Store<CoreUiPartialState>,
    private router: Router,
    private ngZone: NgZone,
    private messageService: MessageService,
    private storeCentral: Store<CentralPartialState>,
    private cdr: ChangeDetectorRef,
    @Inject(LOCALE_ID) public locale: string,
  ) {
    this.frameworkComponents = {
      actionRenderer: CustomerPOSJobOrderGridActionRenderComponent,
    };
    this.context = { componentParent: this };
    this.gridOptions = this.gridOptionsData();
  }

  ngOnInit(): void {
    // Load filter state from localStorage on initialization
    const storedSelectedStatusCodes = localStorage.getItem('selectedStatusCodes');
    if (storedSelectedStatusCodes) {
      this.selectedStatusCodes = JSON.parse(storedSelectedStatusCodes);
    }
    const storedFilterAssignedToMe = localStorage.getItem('filterAssignedToMe');
    if (storedFilterAssignedToMe) {
      this.filterAssignedToMe = JSON.parse(storedFilterAssignedToMe);
    }
    if (this.selectedStatusCodes.length > 0 || this.filterAssignedToMe) {
      this.isShowAdvanceFilter = true;
    }

    this.coreUiStore
      .select(getBrandDefaults)
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe((data) => {
        if (data) {
          this.currencyCode = data?.currrencyCode;
        }
      });

    this.customerStore
      .select(ordersQuery.getIsFetchingJdeOrder)
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe((x) => {
        // forward store value into the internal BehaviorSubject
        this._loadingFetchingOrderFromJDE.next(x);
      });
    this.customerStore.dispatch(new GetUserSalesPersonListAction());
    this.subscribeToStore();
    this.selectedShow = this.previouslySelectedShow;
    this.selectedShowOrderType = this.previouslySelectedShowOrderType;

    // Load click and collect status from store, only fetch from API if not available
    this.customerStore.dispatch(new GetClickAndCollectStatusAction());
  }

  private subscribeToStore() {
    this.customerStore
      .select(customersQuery.getJobRequestActiveNavIndex)
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe((index) => {
        this.setActiveNav(index);
        this.jobRequestActiveNavIndex = index;
      });
    this.storeCentral.dispatch(new LoadOpenJobRequestTotals());

    this.storeCentral.pipe(select(centralQuery.getOpenJobRequestTotals), takeUntil(this.unSubscribe$)).subscribe((data) => {
      if (
        this.router.url.startsWith('/pos/my-orders/pos-arb-orders') &&
        data &&
        JSON.stringify(data) !== JSON.stringify(this.lastCentralJobRequestData)
      ) {
        this.lastCentralJobRequestData = data;
        this.updateNotificationNavs(data);
        this.cdr.detectChanges();
      }
    });

    this.customerStore
      .select(customersQuery.getClickAndCollectStatus)
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe((data) => {
        this.clickAndCollectStatus = data;
      });
  }

  // Update notification navigation badges
  private updateNotificationNavs(data: any) {
    this.notificationNavs[0].badgeCount = data?.clickAndCollectAwaitingApprovalCount || 0;
    this.notificationNavs[1].badgeCount = data?.ecomQuotesAwaitingApprovalCount || 0;
    this.notificationNavs[2].badgeCount = data?.fordLicensedAccessoriesAwaitingApprovalCount || 0;
    this.notificationNavs[3].badgeCount = data?.fleetAwaitingApprovalCount || 0;
    this.notificationNavs[4].badgeCount = data?.tradeShowOrdersAwaitingApprovalCount || 0;
    this.setActiveNav(this.jobRequestActiveNavIndex);
    this.cdr.detectChanges();
  }

  ngOnDestroy(): void {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }

  // Fetch open ARB job orders
  fetchOpenArbOrders() {
    this.loading = true;
    this.apiService
      .fetchOpenClickAndCollect()
      .pipe(takeUntil(this.unSubscribe$), finalize(() => {
        this.loading = false;
      }))
      .subscribe({
        next: (res) => {
          this.rowData = res.orderList;
          this.applyFilters();
        },
        error: () => {
          // loading handled in finalize
        },
      });
  }

  FetchOpenEcomQuotes() {
    this.loading = true;
    this.apiService
      .fetchOpenEcomQuotes()
      .pipe(takeUntil(this.unSubscribe$), finalize(() => {
        this.loading = false;

      }))
      .subscribe({
        next: (res) => {
          this.rowData = res.orderList;
          this.applyFilters();
        },
        error: () => {
          // loading handled in finalize
        },
      });
  }

  fetchOpenFLAOrders() {
    this.loading = true;
    this.apiService
      .fetchOpenFLAOrders()
      .pipe(takeUntil(this.unSubscribe$), finalize(() => {
        this.loading = false;
      }))
      .subscribe({
        next: (res) => {
          this.rowData = res.orderList;
          this.applyFilters();
        },
        error: () => {
          // loading handled in finalize
        },
      });
  }

  fetchCustomerShowList() {}

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    const sortModel = [{ colId: 'dateTime', sort: 'desc' }];

    // Apply column visibility based on current active nav after grid is ready
    if (this.jobRequestActiveNavIndex >= 0) {
      this.applyColumnVisibility(this.jobRequestActiveNavIndex);
    }

    // Listen to column resize events to update header name dynamically
    this.gridApi.addEventListener('columnResized', (event) => {
      if (event.finished && event.columns && event.columns.length > 0) {
        const resizedColumn = event.columns.find((col) => col.getColId() === 'ecomOrderNumber');
        if (resizedColumn) {
          this.updateEcomOrderHeaderName(resizedColumn.getActualWidth());
        }
      }
    });
  }

  private updateEcomOrderHeaderName(width: number): void {
    if (!this.gridApi || !this.gridColumnApi) return;
    const headerName = width > 216 ? 'ECOMMERCE ORDER NO' : 'ECOM ORDER NO';
    const column = this.gridColumnApi.getColumn('ecomOrderNumber');
    if (column) {
      const colDef = column.getColDef();
      if (colDef && colDef.headerName !== headerName) {
        // Create a new column definitions array with the updated header
        const currentColDefs = this.gridOptions.columnDefs;
        if (currentColDefs) {
          const newColDefs = currentColDefs.map((col) => {
            // Type guard to check if it's a ColDef (not ColGroupDef)
            if ('colId' in col || 'field' in col) {
              const colDef = col as ColDef;
              if (colDef.colId === 'ecomOrderNumber' || colDef.field === 'ecomOrderNumber') {
                return { ...colDef, headerName: headerName };
              }
            }
            return col;
          });
          this.gridApi.setColumnDefs(newColDefs);
        }
      }
    }
  }

  private applyColumnVisibility(index: number): void {
    if (!this.gridColumnApi) return;

    if (index === 0) {
      this.gridColumnApi.setColumnVisible('orderStatus', true);
      this.gridColumnApi.setColumnVisible('pickupDate', true);
      this.gridColumnApi.setColumnVisible('orderTypeDesc', false);
      this.gridColumnApi.setColumnVisible('orderValue', false);
      this.gridColumnApi.setColumnVisible('ecomOrderNumber', true);
    } else if (index === 1) {
      this.gridColumnApi.setColumnVisible('orderStatus', false);
      this.gridColumnApi.setColumnVisible('pickupDate', false);
      this.gridColumnApi.setColumnVisible('orderTypeDesc', false);
      this.gridColumnApi.setColumnVisible('ecomOrderNumber', true);
    } else if (index === 2) {
      this.gridColumnApi.setColumnVisible('orderStatus', false);
      this.gridColumnApi.setColumnVisible('pickupDate', false);
      this.gridColumnApi.setColumnVisible('ecomOrderNumber', false);
      this.gridColumnApi.setColumnVisible('orderTypeDesc', false);
    } else if (index === 4) {
      this.gridColumnApi.setColumnVisible('orderStatus', false);
      this.gridColumnApi.setColumnVisible('pickupDate', false);
      this.gridColumnApi.setColumnVisible('orderTypeDesc', true);
    }
  }

  gridOptionsData() {
    return {
      defaultColDef: {
        resizable: true,
        sortable: true,
        minWidth: 150,
        flex: 1,
        cellClass: 'cell-class ag-right-aligned-cell',
        headerClass: 'header-class ag-left-aligned-header',
      },
      columnDefs: [
        {
          headerName: 'ACTION',
          maxWidth: 150,
          flex: 1,
          cellRenderer: 'actionRenderer',
          cellStyle: { 'text-align': 'left' },
        },

        {
          headerName: 'STATUS',
          minWidth: 150,
          flex: 1,
          field: 'orderStatus',
          cellStyle: { 'text-align': 'left' },
        },

        {
          headerName: 'ORDER NO',
          maxWidth: 150,
          field: 'orderNumber',
          cellRenderer: (params) => this.createOrderLink(params),
          cellStyle: { 'text-align': 'left' },
        },
        {
          headerName: 'ORDER Type',
          minWidth: 150,
          flex: 1,
          field: 'orderTypeDesc',
          cellStyle: { 'text-align': 'left' },
        },
        {
          headerName: 'SALES PERSON',
          minWidth: 200,
          flex: 1,
          field: 'salesperson',
          cellStyle: { 'text-align': 'left' },
        },

        {
          headerName: 'CUSTOMER NAME',
          minWidth: 200,
          flex: 1,
          field: 'customer',
          cellStyle: { 'text-align': 'left' },
        },
        {
          headerName: 'PHONE',
          maxWidth: 150,
          flex: 1,
          field: 'customerPhone',
          cellStyle: { 'text-align': 'left' },
        },
        {
          headerName: 'ECOM ORDER NO',
          colId: 'ecomOrderNumber',
          minWidth: 130, // Minimum width to fit "ECOM ORDER NO" without ellipsis
          maxWidth: 220,
          resizable: true,
          field: 'ecomOrderNumber',
          cellStyle: { 'text-align': 'left' },
          suppressSizeToFit: false,
        },
        {
          headerName: 'ORDER VALUE',
          minWidth: 150,
          flex: 1,
          field: 'orderValue',
          cellStyle: { 'text-align': 'left' },
          hide: true,
        },

        {
          headerName: 'DATE / TIME RAISED',
          minWidth: 200,
          flex: 1,
          field: 'dateRaised',
          valueFormatter: this.dateFormatter,
          cellStyle: { 'text-align': 'left' },
          comparator: (valueA, valueB) => {
            const dateA = moment(valueA, 'DD/MM/YYYY');
            const dateB = moment(valueB, 'DD/MM/YYYY');
            return dateA.valueOf() - dateB.valueOf();
          },
        },
        {
          headerName: 'pickup Date ',
          minWidth: 200,
          flex: 1,
          field: 'pickupDate',
          valueFormatter: this.dateFormatterPickupDate,
          cellStyle: (params) => {
            if (
              params?.data?.jobRequestOrderStatus === 10 ||
              moment(params?.data?.pickupDate, 'DD/MM/YYYY').isBefore(moment(new Date(), 'DD/MM/YYYY'))
            ) {
              return { 'text-align': 'left', 'background-color': 'red' };
            }
            return { 'text-align': 'left' };
          },
          comparator: (valueA, valueB) => {
            const dateA = moment(valueA, 'DD/MM/YYYY');
            const dateB = moment(valueB, 'DD/MM/YYYY');
            return dateA.valueOf() - dateB.valueOf();
          },
        },
      ],
    };
  }

  private createOrderLink(params): HTMLAnchorElement {
    const link = document.createElement('a');
    link.href = 'javascript:void(0)';
    link.innerText = params.value;
    link.addEventListener('click', () => {
      this.fetchOrderFromJDE(params.data);
    });
    return link;
  }

  dateComparator(date1: string, date2: string): number {
    const dateParts1 = date1.split('/').map((part) => parseInt(part, 10));
    const dateParts2 = date2.split('/').map((part) => parseInt(part, 10));
    const d1 = new Date(dateParts1[2], dateParts1[1] - 1, dateParts1[0]);
    const d2 = new Date(dateParts2[2], dateParts2[1] - 1, dateParts2[0]);
    return d1.getTime() - d2.getTime();
  }

  dateFormatter(params) {
    //get time as params.data.timeRaised
    //add to date and return  moment(params.value).format('L <HH:mm>')
    if (!params.value) {
      return '';
    }

    const time = getformatedTime(params.data.timeRaised.toString());
    return params.value + ' <' + time + '>';
  }

  dateFormatterPickupDate(params) {
    if (!params.value) {
      return '';
    }
    return params.value;
  }

  attachedItem(cell, isReadOnly) {
    this.entityId = `${cell.orderNumber.toString()}|${cell.orderType}|${this.defaultCompanyCode}`;
    this.entityType = 'order';
    this.orderDetails = cell;
    this.isReadOnlyLineAttachment = isReadOnly;
    this.isShowOrderAttachment = true;
    this.loading = true;
    this.apiService
      .loadAttachmentForOrder({
        orderNumber: cell.orderNumber,
        orderType: cell.orderType,
        JDEOrderType: cell?.JDEOrderType,
        JDECompany: cell?.JDECompany,
      })
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe((res: any) => {
        this.loading = false;
        this.allAttachments = res?.attachmentIDArray;
        this.openModalBox();
      });
  }

  downloadFile(item) {
    this.apiService.downloadFile(item._id, item.name).subscribe(() => {});
  }

  closeModal() {
    this.modalService.dismissAll();
  }

  formatTime(time) {
    // JDE time doesn't put a 0 at the start when less than 10am
    if (parseInt(time.slice(0, 2)) > 24) {
      return ['0' + time.slice(0, 1), ':', time.slice(1, 3)].join('');
    } else {
      return [time.slice(0, 2), ':', time.slice(2, 4)].join('');
    }
  }

  fetchOrderFromJDE(data) {
    this.customerStore.dispatch(
      new FetchJdeOrder({
        orderNumber: data.orderNumber,
        orderType: data.orderType,
        JDEOrderType: data?.JDEOrderType,
        JDECompany: data?.JDECompany,
      }),
    );
  }

  displayPrice(price: number) {
    if (!price) {
      return '';
    }
    return getUserAssignedCurrencyFormat(price, this.locale, this.currencyCode);
  }

  loadTask(data) {
    this.router.navigate([`central/task-search-order/${data.orderNumber}/${data.orderType}`]);
  }

  changeSalesPerson(cell) {
    this.orderDetails = cell;
    this.customerStore
      .select(customersQuery.getUserSalespersonList)
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe((data) => {
        if (data) {
          this.salesPeopleList = data;
          if (this.salesPeopleList?.length > 0) {
            this.isShowSalesPersonSelector = true;
            this.openModalBox();
          } else {
            this.toastr.error('No salesperson list found');
          }
        }
      });
  }

  reloadData() {
    this.fetchOpenArbOrders();
    this.selectedSalesPerson = null;
    this.modalService.dismissAll();
  }

  handleCloseAttachmentModel(event) {
    if (this.isShowOrderAttachment) {
      if (this.madeChanges) {
        this.loading = true;
        this.modalService.dismissAll();
        this.apiService
          .saveAttachmentForOrder({
            orderNumber: this.orderDetails.orderNumber,
            orderType: this.orderDetails.orderType,
            JDEOrderType: this.orderDetails?.JDEOrderType,
            JDECompany: this.orderDetails?.JDECompany,
          })
          .pipe(takeUntil(this.unSubscribe$))
          .subscribe((res: any) => {
            this.loading = false;
            this.allAttachments = res?.attachmentIDArray;
            this.madeChanges = false;
            if (event) {
              this.isShowOrderAttachment = false;
              this.fetchOpenArbOrders();
            }
          });
      } else {
        this.loading = true;
        this.modalService.dismissAll();
        this.apiService
          .unloadAttachmentForOrder({
            orderNumber: this.orderDetails.orderNumber,
            orderType: this.orderDetails.orderType,
          })
          .pipe(takeUntil(this.unSubscribe$))
          .subscribe((res: any) => {
            this.loading = false;
            this.allAttachments = res?.attachmentIDArray;
            if (event) {
              this.isShowOrderAttachment = false;
            }
          });
      }
    }
  }

  addNewTaskForOrder(data) {
    this.orderDetails = data;
    this.coreUiStore.dispatch(saveCustomerOrderDetailsForTask({ customerOrderDetails: { ...data, newTask: true } }));
    this.router.navigate([`central/task/new`]);
  }

  openModalBox() {
    this.modalService
      .open(this.modalBox, {
        windowClass: 'garage-modal',
        size: 'xl',
        backdrop: 'static',
      })
      .result.then(
        (_) => {
          this.isShowOrderAttachment = false;
          this.isShowSalesPersonSelector = false;
        },
        (_) => {
          this.isShowOrderAttachment = false;
          this.isShowSalesPersonSelector = false;
        },
      );
  }

  loadAllAttachments(attachments: any) {
    this.madeChanges = true;
    this.allAttachments = attachments;
  }

  saveTask(objectToUpdate) {
    this.apiService.maintainTask(objectToUpdate).subscribe((res) => {
      if (res?.ErrorFlag === '0') {
        this.toastr.success('Task Updated Successfully');
        this.formValid = false;
        this.coreUiStore.dispatch(hasUnsavedChanges({ unsavedChanges: false }));
        this.messageService.dispatchAction(hasUnsavedChanges({ unsavedChanges: false }));
        this.modalService.dismissAll();
        this.fetchOpenArbOrders();
      }
    });
  }

  setActiveNavClick(index: number) {
    this.router.navigateByUrl('pos/my-orders/pos-arb-orders');
    this.setActiveNav(index);
  }
  setActiveNav(index: number): void {
    //if( index does not match existing jobRequestActiveNavIndex) then
    if (this.jobRequestActiveNavIndex !== index) {
      if (index === 0) {
        this.fetchOpenArbOrders();
        this.isClickAndCollect = true;
        this.isEcomQuote = false;
        this.applyColumnVisibility(0);
      } else if (index === 1) {
        this.FetchOpenEcomQuotes();
        this.isClickAndCollect = false;
        this.isEcomQuote = true;
        this.applyColumnVisibility(1);
      } else if (index === 2) {
        // temporary until we have data for other navs
        this.fetchOpenFLAOrders();
        this.isClickAndCollect = false;
        this.isEcomQuote = false;
        this.isFLAOrder = true;
        this.applyColumnVisibility(2);
      } else if (index === 4) {
        // temporary until we have data for other navs
        this.loading = true;
        this.apiService
          .getCustomerShowList()
          .pipe(takeUntil(this.unSubscribe$), finalize(() => {
            this.loading = false;

          }))
          .subscribe({
            next: (res) => {
              this.customerShowList = res.SearchResults;
              if (this.selectedShow && this.selectedShowOrderType && res.SearchResults) {
                this.applyTradeShowOrderSearch();
                this.showTradeShowOrderListMenuOnly = false;
              } else {
                this.showTradeShowOrderListMenuOnly = true;
              }
              this.isClickAndCollect = false;
              this.isEcomQuote = false;
              this.isFLAOrder = false;
            },
            error: (error) => {
              this.toastr.error(error?.ErrorMessage || 'Error fetching customer show list');
              this.gridApi?.setRowData([]);
              this.gridApi?.paginationGoToPage(0);
            },
          });
      } else {
        // temporary until we have data for other navs
        this.gridApi?.setRowData([]);
        this.gridApi?.paginationGoToPage(0);
      }
      this.jobRequestActiveNavIndex = index;
      this.customerStore.dispatch(new saveJobRequestActiveNavIndex(index));
    } else {
      // Same tab - just apply filters to existing data
      if (this.rowData && this.rowData.length > 0) {
        this.applyFilters();
      }
    }
  }

  changePickupDate(newDate: string, data: any) {
    if (newDate === data.pickupDate) {
      return;
    }
    const [day, month, year] = newDate.split('/').map(Number);
    const dateObject = new Date(year, month - 1, day);

    // Get today's date at midnight
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (dateObject >= today) {
      const dataHeader = {
        requestDate: newDate,
        orderNumber: data.orderNumber,
        JDEOrderType: data?.JDEOrderType,
        JDECompany: data?.JDECompany,
      };

      this.apiService
        .updateRequestDateOfSavedOrder(dataHeader)
        .pipe(takeUntil(this.unSubscribe$))
        .subscribe({
          next: (res) => {
            if (res) {
              this.toastr.success('Pickup date updated successfully');
              this.reloadData();
            }
          },
          error: (error) => {
            this.toastr.error(error?.ErrorMessage || 'An error occurred while updating the request date');
          },
        });
    } else {
      this.toastr.error("Request date cannot be earlier than today's date");
    }
  }

  applyFilters() {
    const userProfile = JSON.parse(localStorage.getItem(KEYS.jdeSession));
    const filtersActive = this.filterAssignedToMe || this.selectedStatusCodes.length > 0;

    this.filteredRowData = this.rowData.filter((item) => {
      // if no filters selected, return all rows
      if (!filtersActive) {
        return true;
      }

      const userName = userProfile?.Name;
      const statusFiltersActive = this.selectedStatusCodes.length > 0;

      // when "Assigned to me" is true and no status filters selected,
      // show all rows for which salesperson matches current user
      if (this.filterAssignedToMe && !statusFiltersActive) {
        return item.salesperson === userName;
      }

      // if status filters are active, check if item matches any selected status code
      const statusMatch = statusFiltersActive ? this.selectedStatusCodes.includes(String(item.orderStatusCode)) : false;

      // if both assignedToMe and status filters are active, require both to match
      if (this.filterAssignedToMe && statusFiltersActive) {
        return item.salesperson === userName && statusMatch;
      }

      // otherwise (assignedToMe is false but status filters active), match by status
      return statusMatch;
    });
    // If grid is already initialized, push the filtered data to it so the UI updates immediately.
    if (this.gridApi) {
      this.gridApi.setRowData(this.filteredRowData);
      // reset to first page when filters change
      try {
        this.gridApi.paginationGoToPage(0);
      } catch (e) {
        // ignore if pagination not available yet
      }
    }
  }

  toggleStatusFilter(statusCode: string) {
    const index = this.selectedStatusCodes.indexOf(statusCode);
    if (index > -1) {
      this.selectedStatusCodes.splice(index, 1);
    } else {
      this.selectedStatusCodes.push(statusCode);
    }
    localStorage.setItem('selectedStatusCodes', JSON.stringify(this.selectedStatusCodes));
    this.applyFilters();
  }

  onAssignedToMeChange() {
    localStorage.setItem('filterAssignedToMe', JSON.stringify(this.filterAssignedToMe));
    this.applyFilters();
  }

  isStatusSelected(statusCode: string): boolean {
    return this.selectedStatusCodes.includes(statusCode);
  }
  resetFilters() {
    this.filterAssignedToMe = false;
    this.selectedStatusCodes = [];
    localStorage.removeItem('selectedStatusCodes');
    localStorage.removeItem('filterAssignedToMe');
    this.applyFilters();
  }

  applyTradeShowOrderSearch() {
    this.loading = true;
    const userProfile = JSON.parse(localStorage.getItem(KEYS.jdeSession));
    localStorage.setItem(KEYS.jdeSession, JSON.stringify({ ...userProfile, ShowCode: this.selectedShow, ShowOrderType: this.selectedShowOrderType }));
    this.apiService
      .fetchShowOrdersAndQuotes({
        showCode: this.selectedShow,
        orderType: this.selectedShowOrderType[0],
      })
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe({
        next: (res) => {
          this.loading = false;
          this.rowData = res.SearchResults || [];
          this.showTradeShowOrderListMenuOnly = false;
          this.applyColumnVisibility(4);
          this.gridApi?.setRowData(this.rowData);
        },
        error: () => {
          this.loading = false;
        },
        complete: () => {
          this.loading = false;
        },
      });
  }

  setShowCode(showCode: string) {
    this.selectedShow = showCode;
  }
}

